(function() {
	'use strict';
	angular.module('app.supplyChain')
		.controller('purchaseOrderCompliance', purchaseOrderCompliance);

	purchaseOrderCompliance.$inject = ['$scope', '$rootScope', '$timeout', '$state', '$location', 'leanFilterService',
		'tableService', 'redirectParamsService',  'tableRenderService', 'storeService'];
	function purchaseOrderCompliance($scope, $rootScope, $timeout, $state, $location, leanFilterService, tableService,
			redirectParamsService, tableRenderService, storeService) {

		var vm = this;
		var unsubscribe;

		var rendererParams = {
			'multiFactory': true,
			'specificTaskType': 'task'
		};
		var reportSettingsName = 'purchase-order-compliance';
		var pinnedColumns = [];
		var defaultFilters = [];
		var extraParams = [{
			excelReportName: 'PurchaseOrderComplianceReport'
		}];
		var extraFilters = [];

		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;
		$scope.filterService = leanFilterService;
		vm.reportName = 'Purchase order compliance';
		vm.showExcel = true;

		var columns = [
			{
				'id': 'actionStatus',
				'display': 'Task Status',
				'width': 100,
				'renderer': tableRenderService.status,
				'sort': false
			},
			{
				'id': 'itemCode',
				'display': 'Item Code',
				'width': 200,
				'renderer': tableRenderService.itemCode
			},
			{
				'id': 'itemGrpName',
				'display': 'Item Group',
				'width': 120
			},
			{
				id: 'factoryAlias',
				display: 'Site',
				width: 100
			},
			{
				'id': 'supplierCode',
				'display': 'Supplier Code',
				'show': false,
				'width': 100
			},
			{
				'id': 'supplierName',
				'display': 'Supplier',
				'width': 140
			},
			{
				'id': 'buyerCode',
				'display': 'Buyer',
				'width': 140
			},
			{
				'id': 'abcClass',
				'display': 'ABC Class',
				'width': 68,
				'show': false
			},
			{
				'id': 'monthlyRequirement',
				'display': 'Company Defined Demand (Monthly)',
				'width': 110,
				'renderer': tableRenderService.decimal,
				'keepAllDecimals': true,
				'show': false
			},
			{
				'id': 'analysisTotalAnnualDemand',
				'display': '12 Month Requirements',
				'width': 110,
				'renderer': tableRenderService.decimal,
				'show': false
			},
			{
				'id': 'purchaseOrderNumber',
				'display': 'PO Number',
				'width': 100
			},
			{
				'id': 'purchaseOrderLine',
				'display': 'PO Line',
				'width': 64
			},
			{
				'id': 'scheduleLine',
				'display': 'Schedule Line',
				'width': 90
			},
			{
				'id': 'orderDate',
				'display': 'Order Date',
				'width': 100,
				'renderer': tableRenderService.dateRenderer
			},
			{
				'id': 'requestedDate',
				'display': 'Expected Delivery Date',
				'width': 100,
				'renderer': tableRenderService.dateRenderer
			},
			{
				'id': 'remainingQuantityFloat',
				'display': 'Remaining Qty',
				'width': 100,
				'renderer': tableRenderService.integer
			},
			{
				'id': 'daysOfSupply',
				'display': 'Days Of Supply',
				'width': 80,
				'renderer': tableRenderService.integer,
				'show': false
			},
			{
				'id': 'unitPrice',
				'display': 'Unit Price',
				'width': 72,
				'renderer': tableRenderService.currency
			},
			{
				'id': 'poValue',
				'display': 'Po Value',
				'width': 80,
				'renderer': tableRenderService.currency
			},
			{
				'id': 'targetOrderQuantity',
				'display': 'Target Order Quantity',
				'width': 84,
				'renderer': tableRenderService.integer
			},
			{
				'id': 'targetOrderValue',
				'display': 'Target Order Value',
				'width': 80,
				'renderer': tableRenderService.currency,
				'show': false
			},
			{
				'id': 'overTargetValue',
				'display': 'Over Target Value',
				'width': 88,
				'renderer': tableRenderService.currency,
				'sortDefaultReverse': true
			},
			{
				'id': 'orderPolicy',
				'display': 'Order Policy',
				'width': 100
			},
			{
				'id': 'orderPolicyValue',
				'display': 'Order Policy Value',
				'width': 80,
				'renderer': tableRenderService.integer
			},
			{
				'id': 'minimumOrderQuantityFloat',
				'display': 'Minimum Order Qty',
				'width': 84,
				'renderer': tableRenderService.integer
			},
			{
				'id': 'orderMultipleFloat',
				'display': 'Order Multiple',
				'width': 80,
				'renderer': tableRenderService.integer
			},
			{
				'id': 'fixedOrderQuantityFloat',
				'display': 'Fixed Order Qty',
				'width': 84,
				'renderer': tableRenderService.integer
			},
			{
				'id': 'orderIntervalInt',
				'display': 'Order Interval',
				'width': 80,
				'renderer': tableRenderService.integer
			},
			{
				'id': 'leadTimeInDaysFloat',
				'display': 'Lead Time',
				'width': 88,
				'renderer': tableRenderService.integer
			}
		];

		init();
		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportUrl: '{0}/PurchaseOrderComplianceReport',
			noPaging: false,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultSort: 'overTargetValue',
			defaultSortDirection: 'desc',
			defaultFilters: defaultFilters,
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			searchType: 'item',
			extraFilters: extraFilters,
			excelRequest: true,
			setColumnDefaults: true,
			hasMandatoryFilters: globalConfig.user.role !== 'Supplier'
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.broadcastExcel = broadcastExcel;

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}


		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {doChooseColumns: true, exportFileName: reportSettingsId ? vm.reportName : undefined});
		}

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				return response;
			});
		}

		function init() {
			$scope.filterService.clearFilters();
			$scope.filterService.useFactoryFilter = globalConfig.user.role !== 'Supplier';
			if (globalConfig.user.role !== 'Supplier') {
				defaultFilters = [{
					'id': 'factory',
					'values': [globalConfig.factory.id],
					'isMandatory': true
				},
				{
					'id': 'itemGroupNdx',
					'values': [$scope.filterService.leanDnaAllSelected]
				},
				{
					'id': 'supplierNdx',
					'values': [$scope.filterService.leanDnaAllSelected]
				},
				{
					'id': 'buyerCode',
					'values': [$scope.filterService.leanDnaAllSelected]
				}
				];
				var siteFilter = leanFilterService.filterDefinitions['Factory'];
				siteFilter.type = 'multiselect';
				siteFilter.removable = false;
				$scope.filterService.setMasterFilterList([
					siteFilter,
					$scope.filterService.filterDefinitions['Item Group'],
					$scope.filterService.filterDefinitions['Supplier'],
					$scope.filterService.filterDefinitions['Buyer'],
					$scope.filterService.filterDefinitions['ERP Order Policy'],
					$scope.filterService.filterDefinitions['PurchaseDocumentType'],
					$scope.filterService.filterDefinitions['PoPrice'],
					$scope.filterService.filterDefinitions['TaskStatus'],
					$scope.filterService.filterDefinitions['TaskCategory'],
					$scope.filterService.filterDefinitions['Responsible']
				]);
			} else {
				$scope.filterService.setMasterFilterList([
					$scope.filterService.filterDefinitions['ERP Order Policy'],
					$scope.filterService.filterDefinitions['PurchaseDocumentType']
				]);
			}
			$scope.filterService.setMasterRangeFilterList([
				$scope.filterService.filterDefinitions['OnOrderQty'],
				$scope.filterService.filterDefinitions['OrderDate'],
				_.assign({}, $scope.filterService.filterDefinitions['DeliveryDate'], {id: 'requestedDate'}),
				$scope.filterService.filterDefinitions['PromiseDate'],
				$scope.filterService.filterDefinitions['ActualReceiptDate']
			]);
			$scope.filterService.setMasterStringFilterList([
				$scope.filterService.filterDefinitions['PurchaseOrderNumber']
			]);
		}
	}
})();
